export const NAME = 'profile';
export const UPDATE_EMAIL_FORM = 'updateEmailForm';
export const CHANGE_PASSWORD_FORM = 'changePasswordForm';
export const UPDATE_PROFILE_FORM = 'updateProfileForm';
export const VERIFIER_FORM = 'verifierForm';